import getCompatibleWeakMap from 'src/internal/shared/apollo/getCompatibleWeakMap';

import type ObservableStore from 'src/internal/revamp/observable/ObservableStore';

const CompatibleMap = getCompatibleWeakMap();

let sharedObservableStores: WeakMap<symbol, ObservableStore> | null = null;

export function getObservableSharedStores(): WeakMap<symbol, ObservableStore> {
  if (sharedObservableStores) {
    return sharedObservableStores;
  }

  sharedObservableStores = new CompatibleMap<symbol, ObservableStore>();
  return sharedObservableStores;
}

/**
 * Returns an {@link ObservableStore}, optionally reusing one passed explicitly or
 * registered under `sharedStoreId` (same symbol-keyed map pattern as `getCache` in
 * `src/internal/revamp/apollo/getCache.tsx`).
 *
 * When using `sharedStoreId`, the `factory` should close over a single consistent set of
 * revamp dependencies (`MemoryCache`, `ResultStore`, `ApolloLinkExecutor`, etc.); otherwise
 * a cached store may point at stale collaborators.
 */
export function getObservableStore(
  factory: () => ObservableStore,
  sharedStoreId?: symbol,
): ObservableStore {
  const sharedStores = getObservableSharedStores();

  if (sharedStoreId) {
    const existingStore = sharedStores.get(sharedStoreId);

    if (existingStore) {
      return existingStore;
    }
  }

  const store = factory();

  if (sharedStoreId) {
    sharedStores.set(sharedStoreId, store);
  }

  return store;
}
